import { defineSlotRecipe, defineStyle } from '@chakra-ui/react';

export const radioGroupSlotRecipe = defineSlotRecipe({
  slots: ['root', 'label', 'item'],
  base: {
    label: defineStyle({
      _disabled: { opacity: 0.4 },
    }),
    root: defineStyle({
      '& label': {
        fontSize: 'sm !important',

        '& [data-part="item-text"]': {
          paddingLeft: 2,
        },
      },
    }),
  },
});

export default radioGroupSlotRecipe;
